import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_SE.json';
import exercises from './FITNESS_EXERCISES_SE.json';
import recipes from './FITNESS_RECIPES_SE.json';

export const FITNESS_DATA_SE: ServiceData = {
  articles,
  exercises,
  recipes,
};
